"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import { useRouter } from "next/navigation"
import useGetProvider from "../../../../../hooks/useGetProvider"
import useNavigationRequests from "../../../../../hooks/useNavigationRequests"
import { AUTH_ROLE_ZEST_PROVIDER } from "../../../../../lib/constants"

/**
 * Replicates the old MUI contained small Button: white pill, 13px uppercase
 * label, elevation 2 shadow, rgba-white hover.
 */
const BANNER_BUTTON_CLASSES =
  "min-w-[210px] cursor-pointer rounded-[20px] border-0 bg-white px-[10px] py-1 font-roboto text-[13px] leading-[18px] font-medium tracking-[0.02857em] uppercase text-[#092C3C] shadow-[0px_3px_1px_-2px_rgba(0,0,0,0.2),0px_2px_2px_0px_rgba(0,0,0,0.14),0px_1px_5px_0px_rgba(0,0,0,0.12)] transition-colors hover:bg-white/80"

function ProviderOnboardingBanner() {
  const router = useRouter()
  const { enabled: navigationEnabled, authRole } = useNavigationRequests()
  const enabled = navigationEnabled && authRole === AUTH_ROLE_ZEST_PROVIDER

  const [{ loading, countRemainingOnboardingSteps }] = useGetProvider({ enabled })

  // Don't show anything while loading or if no steps remaining
  if (!enabled || loading || countRemainingOnboardingSteps === 0) return null

  return (
    <div className="w-full bg-black text-white py-2 flex justify-center">
      <div className="flex flex-row max-w-1100px w-[calc(100%-32px)]  px-[16px] justify-center items-center">
        <span className="truncate mr-[5px]">
          To market your group, complete onboarding steps
        </span>
        <button
          type="button"
          onClick={() => router.push("/onboarding")}
          className={BANNER_BUTTON_CLASSES}
        >
          Complete onboarding now
        </button>
      </div>
    </div>
  )
}

export default ProviderOnboardingBanner
